import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface SearchButtonProps {
  onClick: () => void;
  isLoading: boolean; // Nova prop
}

const SearchButton: React.FC<SearchButtonProps> = ({ onClick, isLoading }) => {
  const { t } = useTranslation();

  return (
    <motion.button
      onClick={onClick}
      disabled={isLoading}
      className="flex h-12 w-full sm:w-auto cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-gradient-primary text-white gap-2 text-sm font-bold leading-normal tracking-[0.015em] px-6 hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:opacity-50"
      whileHover={{ scale: isLoading ? 1 : 1.05 }}
      whileTap={{ scale: isLoading ? 1 : 0.95 }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.4, duration: 0.3 }}
    >
      {isLoading ? (
        <>
          <span className="material-symbols-outlined animate-spin">sync</span>
          {t('dashboard.loading')}
        </>
      ) : (
        <>
          <motion.span
            className="material-symbols-outlined"
            initial={{ rotate: 0 }}
            whileHover={{ rotate: 360 }}
            transition={{ duration: 0.5 }}
          >
            search
          </motion.span>
          {t('dashboard.search_button')}
        </>
      )}
    </motion.button>
  );
};

export default SearchButton;